import AsyncStorage from '@react-native-async-storage/async-storage';
import SentryService from '../sentry/Sentry.service';

export enum StorageKeys {
  ENVIRONMENT_NAME = 'environmentName',
  USER_TYPE = 'userType',
  LOCAL_IP = 'localIP',
  EVENT_BANNER_DISMISSED = 'event_banner_dismissed',
  LAST_USER_ACTIVITY_TRIGGER = 'last_user_activity_trigger',
}

export class StorageService {
  static async setItem(key: StorageKeys, value: string): Promise<void> {
    try {
      await AsyncStorage.setItem(key, value);
    } catch (error) {
      SentryService.captureError(`Error saving ${key} to AsyncStorage:`, error);
    }
  }

  static async getItem(key: StorageKeys): Promise<string | null> {
    try {
      return await AsyncStorage.getItem(key);
    } catch (error) {
      SentryService.captureError(
        `Error retrieving ${key} from AsyncStorage:`,
        error,
      );
      return null;
    }
  }

  static async removeItem(key: StorageKeys): Promise<void> {
    try {
      await AsyncStorage.removeItem(key);
    } catch (error) {
      SentryService.captureError(
        `Error removing ${key} from AsyncStorage:`,
        error,
      );
    }
  }
}
